<!--
Created on 2021-04-16
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-16
-->

<template>
  <!-- card database sync -->
  <div class="card card-style">
    <div class="content">
      <h3>Databáza</h3>
      <p class="mb-4">
        Synchronizácia databázy prebehne automaticky, ale môžete ju aj vyvolať manuálne.
      </p>
      <p class="mb-2">
        Posledná synchronizácia: <span class="color-blue-light">{{ lastSyncTime }}</span>
      </p>
      <div @click="$emit('onStartSync')" class="btn btn-m mt-2 mb-2 btn-full bg-highlight rounded-sm text-uppercase font-900">Synchronizovať</div>
    </div>   
  </div>
</template>

<script>
import { ref } from 'vue'
import util from '@/lib/util'
import storage from '@/lib/storage'

export default {
  name: 'DatabaseCard',
  setup() {
    const lastSyncTime = ref(util.getLastSyncText((storage.getSettings('lastSyncTime') || {}).value))

    return {
      lastSyncTime,
    }
  }
}
</script>
